export default __webpack_public_path__ + "static/media/dansketext-regular.e959c702.eot";